import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import InputField from '../../../../reusable-components/InputField';
import { Row, Col, Button, Media } from 'react-bootstrap';
import { required } from '../../../../utils/validations';
import Header from '../../../../reusable-components/Header';
import Footer from '../../../../reusable-components/Footer';
import Body from '../../../../reusable-components/Body';
import Spinner from '../../../../reusable-components/Spinner';
import PageContent from '../../../../reusable-components/ActivatePageContent';
import PageHeader from '../../../../reusable-components/ActivatePageHeader';
import PropTypes from 'prop-types';
import FileBase64 from 'react-file-base64';

export default class StepFiveComponent extends Component {
  constructor(props){
    super(props);
    this.state = {
      near_image: null,
      far_image: null,
      // nearImageDivStyle: null,
      // nearImageDivStyle: { backgroundImage: 'url(' + require('../../../../assets/boat1@ax.jpg') + ')' },
      nearImageDivStyle: require('../../../../assets/boat1@ax.jpg'),
      // farImageDivStyle: null,
      // farImageDivStyle:  { backgroundImage: 'url(' + require('../../../../assets/boot2@ax.jpg') + ')' },
      farImageDivStyle:  require('../../../../assets/boot2@ax.jpg'),
      errors: null,
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  getFiles(photolabel, file){
    this.setState({ [photolabel]: file });
  }

  onSubmit(e){
    e.preventDefault();
    const { uploadImage, history } = this.props;
    const { near_image, far_image } = this.state;
    if (near_image && far_image) {
      let near_image_splits = near_image.base64.split(",");
      let far_image_splits = far_image.base64.split(",");

      let data = {
        detail_photo: near_image_splits[1],
        distant_photo: far_image_splits[1]
      }
      uploadImage(data, history);
    } else {
      this.setState({errors: "Voeg afbeeldingen toe"});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.far_image !== prevState.far_image) {
      var divStyle = {
        backgroundImage: 'url(' + this.state.far_image.base64 + ')'
      }
      this.setState({
        // farImageDivStyle: divStyle
        farImageDivStyle: this.state.far_image.base64
      });
    }
    if (this.state.near_image !== prevState.near_image) {
      var divStyle = {
        backgroundImage: 'url(' + this.state.near_image.base64 + ')'
      }
      this.setState({
        // nearImageDivStyle: divStyle
        nearImageDivStyle: this.state.near_image.base64
      });
    }
  }

  render() {
    const { handleSubmit, isloading } = this.props;

    let buttonState = isloading ? <Spinner /> : "Doorgaan";
    let type_of_boat = localStorage.getItem('object');
    let header = null;
    let photo_1_upload_instruction = null;
    let photo_2_upload_instruction = null;

    if (type_of_boat === 'Boat') {
      header = 'Neem aub 2 foto\'s van uw boot';
      photo_1_upload_instruction = 'Maak een foto van uw boot waarop het vignet leesbaar is';
      photo_2_upload_instruction = 'Maak een foto waar uw volledige boot op zichtbaar is';
    } else if (type_of_boat === 'Woonboot') {
      header = 'Neem aub 2 foto\'s van uw boot';
      photo_1_upload_instruction = 'Maak een foto van uw boot waarop het vignet leesbaar is';
      photo_2_upload_instruction = 'Maak een foto waar uw volledige boot op zichtbaar is';
    } else {
      header = 'Neem aub 2 foto\'s van de steiger';
      photo_1_upload_instruction = 'Neem een foto van de steiger waarop het vignet leesbaar is.';
      photo_2_upload_instruction = 'Neem een foto waarop de complete steiger zichtbaar is.';
    }

    return (
      <React.Fragment>
        <PageHeader title="Fotos" />
        <PageContent 
          title={header}
          goBack={() => this.props.history.goBack()}
          moveNext={() => {}}
          cardClass="card-container"
          showFooter={true}
          hasSubmitBtn={true}
          hasBackBtn={true}
          formClassNames=""
          customfooterbtnContainer="custom-footer-btn-container"
          buttonState={isloading}
          submitting={isloading}
          errors={this.state.errors}
          btnDisabled={isloading}
          handleSubmit={this.onSubmit}>
        <div className="form-container file-upload-container">
          <Row>
            <Col sm={12} md={12}>
            <Media className="image-media">
              <label className="upload-preview mr-3" >
                {/*<div className="image-preview preview-1" style={this.state.nearImageDivStyle2}></div>*/}
                <img src={this.state.nearImageDivStyle} className="image-p" />
                <FileBase64
                  multiple={ false }
                  onDone={ this.getFiles.bind(this, 'near_image') } />
              </label>
              <Media.Body>
                <h5 className="mt-2">Detail foto</h5>
                <p>{photo_1_upload_instruction}</p>
                <label className="btn upload-btn">
                  Toevoegen
                  <FileBase64
                    multiple={ false }
                    onDone={ this.getFiles.bind(this, 'near_image') } />
                </label>
              </Media.Body>
            </Media>
            </Col>
            <Col sm={12} md={12}>
              <Media className="mt-5 image-media">
                <label className="upload-preview mr-3">
                  {/*<div className="image-preview preview-2" style={this.state.farImageDivStyle}></div>*/}
                  <img src={this.state.farImageDivStyle} className="image-p" />
                  <FileBase64
                    multiple={ false }
                    onDone={ this.getFiles.bind(this, 'far_image') } />
                </label>
                <Media.Body>
                  <h5 className="mt-2">Afstand foto</h5>
                  <p>{photo_2_upload_instruction}</p>
                  <label className="btn upload-btn">
                    Toevoegen
                    <FileBase64
                      multiple={ false }
                      onDone={ this.getFiles.bind(this, 'far_image') } />
                  </label>
                </Media.Body>
              </Media>
            </Col>
          </Row>
          {/*<div className="form-row">
            <div className="form-group col-md-3">
              <label className="upload-preview">
                <div className="image-preview" style={this.state.nearImageDivStyle}></div>
                <FileBase64
                  multiple={ false }
                  onDone={ this.getFiles.bind(this, 'near_image') } />
              </label>
            </div>
            <div className="form-group col-md-3 detail-header">
              <h4>Detail foto</h4>
            </div>
            <div className="form-group col-md-6 instruction">
              <span>{photo_1_upload_instruction}</span>
              <label className="btn upload-btn">
                Toevoegen
                <FileBase64
                  multiple={ false }
                  onDone={ this.getFiles.bind(this, 'near_image') } />
              </label>
            </div>
          </div>
          <div className="form-row line-seperator"></div>*/}
          {/*<div className="form-row">
            <div className="form-group col-md-3">
              <label className="upload-preview">
                <div className="image-preview" style={this.state.farImageDivStyle}></div>
                <FileBase64
                  multiple={ false }
                  onDone={ this.getFiles.bind(this, 'far_image') } />
              </label>
            </div>
            <div className="form-group col-md-3 detail-header">
              <h4>Afstand foto</h4>
            </div>
            <div className="form-group col-md-6 instruction">
              <span>{photo_2_upload_instruction}</span>
              <label className="btn upload-btn">
                Toevoegen
                <FileBase64
                  multiple={ false }
                  onDone={ this.getFiles.bind(this, 'far_image') } />
              </label>
            </div>
          </div>*/}
          {/*<div className="content-footer">
            <button 
              type="button" 
              className="btn back-btn"
              onClick={() => {
                this.props.history.goBack();
              }}>
              Terug
            </button>
            <button type="submit" className="btn continue-btn" disabled={isloading}>
              {buttonState}
            </button>
            <button 
              type="button" 
              className="btn skip-btn"
              onClick={() => {
                this.props.history.push('/step/six');
              }}>
              Overslaan
            </button>
          </div>*/}
        </div>
        </PageContent>
      </React.Fragment>
    );
  }
}

StepFiveComponent.propTypes = {
  isloading: PropTypes.bool,
}

